import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Date/number formatting lives in `lib/i18n.ts` (backlog C3) — it is a function
 * of the active locale, so it belongs with the locale store rather than in a
 * generic util module that hardcoded `"de-DE"` and rendered German dates to
 * every English user. Re-exported here so the existing `@/lib/utils` imports
 * keep working; the second argument is the locale from `useTranslation()`, and
 * every component call site now passes it.
 */
export { formatDate, formatDateTime, formatNumber } from "./i18n";

/*
 * Three ported helpers were deleted with C3, all with zero call sites:
 *
 *  - `formatRelativeTime` emitted hardcoded English ("3d ago", "just now",
 *    "soon") into a German-default UI, with no locale parameter and no i18n keys
 *    behind it. A relative formatter belongs on `Intl.RelativeTimeFormat`
 *    alongside the other locale-aware helpers in `lib/i18n.ts` — add it there,
 *    with the locale, when a surface actually needs one.
 *  - `getSeverityLevel` mapped a CVSS score to a severity band: pentest/CMDB
 *    domain, which `.claude/rules/porting.md` puts on the do-not-port list.
 *  - `formatDuration` likewise emitted untranslated "2d 3h" strings.
 */
